export interface WagonStayDuration {
    days?: number
    hours?: number
    minutes?: number
    durationType: WagonStayDurationType
}

export enum WagonStayDurationType {
    LARGER_THAN_24h = 'LargerThan24h',
    SMALLER_THAN_24h = 'SmallerThan24h',
    SMALLER_THAN_1h = 'SmallerThan1h',
}
